'use strict';

import { retainageHeldFromApps, isPostedPayApp } from './pulseTotals.js';

function money(v) {
  const n = typeof v === 'number' ? v : parseFloat(v);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100) / 100;
}

function latestPostedPayApp(payApps) {
  const posted = (payApps || []).filter((pa) => !pa.deleted_at && isPostedPayApp(pa));
  if (!posted.length) return null;
  return [...posted].sort((a, b) => Number(b.app_number) - Number(a.app_number))[0];
}

/** Mirror server/lib/pulseProjectMoney.js — list and detail must match. */
export function pulseProjectMoneyFromPayApps(payApps, { collected = 0, g702TCompByPaId = {} } = {}) {
  const latest = latestPostedPayApp(payApps);
  const heldInfo = retainageHeldFromApps(payApps);
  const billed = latest
    ? money(g702TCompByPaId[latest.id] ?? latest.g702_tcomp ?? latest.pulse_tcomp ?? 0)
    : 0;
  const held = money(heldInfo.held);
  const coll = money(collected);
  const open = money(Math.max(0, billed - held - coll));
  return { billed, held, collected: coll, open };
}

export function pulseProjectMoneyFromProject(project, payApps = []) {
  const apps = Array.isArray(payApps) ? payApps : [];
  if (project?.pulse_billed != null && !apps.length) {
    return {
      billed: money(project.pulse_billed),
      held: money(project.pulse_held),
      collected: money(project.pulse_collected),
      open: money(project.pulse_open),
    };
  }
  const g702TCompByPaId = Object.fromEntries(
    apps
      .filter((pa) => pa.g702_tcomp != null || pa.pulse_tcomp != null)
      .map((pa) => [pa.id, money(pa.g702_tcomp ?? pa.pulse_tcomp)]),
  );
  return pulseProjectMoneyFromPayApps(apps, {
    collected: project?.payments_received ?? project?.pulse_collected ?? 0,
    g702TCompByPaId,
  });
}

export { money, isPostedPayApp, latestPostedPayApp };
